<!--
  ctrDocCnf.vue ( 7 step, mblElcSgn05 + a )
  - 청약서류확인
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header :rtrnAnimInsYn="state.rtrnAnimInsYn" />
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <p class="txt05">
            청약서류, 약관 다운로드 후 화면 하단 '전자서명 전송'을
            눌러주세요.<br />전송 버튼을 눌러야 완료가 됩니다.
          </p>
          <ul class="download_list">
            <li>
              <button type="button" class="btn_doc" @click="sbcpDocDwld">
                <span>청약서류<br />다운로드</span>
              </button>
            </li>
            <li>
              <button type="button" class="btn_agree" @click="insClusDwld">
                <span>보험약관<br />다운로드</span>
              </button>
            </li>
          </ul>
          <p class="txt02">※ 청약서류 문서암호 : 생년월일 6자리</p>
          <p class="txt02">
            ※ 완료된 전자서명은 메리츠화재 전산으로 전송되며 담당자 확인 후
            수납처리가 진행됩니다. 즉시이체를 선택한 경우, 서명 완료시 1회
            보험료 출금과 수납이 진행됩니다.
          </p>
          <p class="tit_tbl">계약기본사항</p>
          <div class="data_table type_row data">
            <table>
              <caption class="blind">
                계약기본사항
              </caption>
              <colgroup>
                <col style="width: 85px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">상품명</th>
                  <td>{{ state.ctrBasInfCoVo.untPdNm }}</td>
                </tr>
                <tr>
                  <th scope="row">가계약번호</th>
                  <td>{{ state.ctrBasInfCoVo.prctrNo }}</td>
                </tr>
                <tr>
                  <th scope="row">계약자</th>
                  <td>{{ state.ctrBasInfCoVo.polhdNm }}</td>
                </tr>
                <tr v-if="state.rtrnAnimInsYn">
                  <th scope="row">반려동물명</th>
                  <td>{{ state.ctrBasInfCoVo.petNm }}</td>
                </tr>
                <tr v-else>
                  <th scope="row">피보험자</th>
                  <td>{{ state.ctrBasInfCoVo.maInspeNm }}</td>
                </tr>
                <tr>
                  <th scope="row">보험기간</th>
                  <td>
                    {{
                      dateFormat(state.ctrBasInfCoVo.insBgnDt) +
                      " ~ " +
                      dateFormat(state.ctrBasInfCoVo.insEdDt)
                    }}
                  </td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.dthErnpeNm != null &&
                    state.ctrBasInfCoVo.dthErnpeNm != ''
                  "
                >
                  <th scope="row">사망수익자</th>
                  <td>{{ state.ctrBasInfCoVo.dthErnpeNm }}</td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.etcErnpeNm != null &&
                    state.ctrBasInfCoVo.etcErnpeNm != ''
                  "
                >
                  <th scope="row">기타수익자</th>
                  <td>{{ state.ctrBasInfCoVo.etcErnpeNm }}</td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.exprErnpeNm != null &&
                    state.ctrBasInfCoVo.exprErnpeNm != ''
                  "
                >
                  <th scope="row">만기수익자</th>
                  <td>{{ state.ctrBasInfCoVo.exprErnpeNm }}</td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.appnSroClmpeNm != null &&
                    state.ctrBasInfCoVo.appnSroClmpeNm != ''
                  "
                >
                  <th scope="row">지정대리청구인</th>
                  <td>{{ state.ctrBasInfCoVo.appnSroClmpeNm }}</td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.appnSroClmpeNm1 != null &&
                    state.ctrBasInfCoVo.appnSroClmpeNm1 != ''
                  "
                >
                  <th scope="row">지정대리청구인</th>
                  <td>{{ state.ctrBasInfCoVo.appnSroClmpeNm1 }}</td>
                </tr>
                <tr v-if="state.ctrBasInfCoVo.bthAftSlzPrem == 0">
                  <th scope="row">보험료</th>
                  <td>
                    <strong class="point02"
                      >{{ numberFormat(state.ctrBasInfCoVo.slzPrem) }}원</strong
                    >
                  </td>
                </tr>
                <tr v-if="state.ctrBasInfCoVo.bthAftSlzPrem > 0">
                  <th scope="row">보험료</th>
                  <td>
                    출생전
                    <strong class="point02"
                      >{{ numberFormat(state.ctrBasInfCoVo.slzPrem) }}원</strong
                    >
                    출생후
                    <strong class="point02"
                      >{{
                        numberFormat(state.ctrBasInfCoVo.bthAftSlzPrem)
                      }}원</strong
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn_area masterBtn">
            <button type="button" class="btn_main" @click="transfer">
              <span>{{ masterButton.label }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer :rtrnAnimInsYn="state.rtrnAnimInsYn" />
    <iframe
      id="downloadFrame"
      ref="downloadFrame"
      style="width: 0px; height: 0px"
      src=""
    ></iframe>
  </div>
</template>
<script>
import { ref, reactive, inject, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import { isIOS } from "mobile-device-detect";
export default {
  name: "ctrDoccnf",
  components: {
    Header,
    Footer,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));
    const downloadFrame = ref(null);

    onMounted(async () => {
      await load();
      util.saveLog("009", "청약서류확인"); // 009 : 화면진입
      if (
        sessionUserInfo.rpsPdCd == "61139" ||
        sessionUserInfo.rpsPdCd == "61238" ||
        sessionUserInfo.rpsPdCd == "61239"
      ) {
        state.rtrnAnimInsYn = true;
      } else {
        state.rtrnAnimInsYn = false;
      }

      state.ctrBasInfCoVo = sessionUserInfo.ctrBasInfCoVo[0];

      let sbcpChnDivCd = state.ctrBasInfCoVo.sbcpChnDivCd;
      state.ctrBasInfCoVo.petNm = sessionUserInfo.patNm;

      //TM채널 여부
      if (sbcpChnDivCd == "11" || sbcpChnDivCd == "12") {
        variables.sbcpChnFlag = true;
      } else {
        variables.sbcpChnFlag = false;
      }

      //갱신형 실손의료보험여부
      if (
        state.ctrBasInfCoVo.rpsPdCd == "61091" ||
        state.ctrBasInfCoVo.rpsPdCd == "60546" ||
        state.ctrBasInfCoVo.rpsPdCd == "60862" ||
        state.ctrBasInfCoVo.rpsPdCd == "60635"
      ) {
        variables.pmmiCovYn = true;
      } else {
        variables.pmmiCovYn = false;
      }

      retrieveMblClus();

      let param = {};
      param.srchTp = "03";
      param.orgStatCd = "1";
      param.orgTpCd = "2";

      //계약자가 내근직 OR 영업가족인지 판단하기 위한 조직정보 조회
      axios.json("/retrieveOrgBasInf.do", param).then(function (result) {
        //내근직 or 영업가족 필터
        let orgList = _.filter(result.data.row, function (info) {
          return info.orgTpCd == "2" && info.orgStatCd == "1";
        });

        if (orgList.length > 0) {
          variables.inempYn = true;
        } else {
          variables.inempYn = false;
        }
      });
    });

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      rtrnAnimInsYn: false,
      ctrBasInfCoVo: {},
      isCnfSbcpDocDwld: false,
      isInsClusDwld: false,
    });

    const variables = {
      sbcpChnFlag: "",
      pmmiCovYn: false,
      insClusDwldUrl: "",
      inempYn: false,
    };

    const masterButton = reactive({
      label: "청약서부본 다운로드",
    });

    function retrieveMblClus() {
      var param = {
        prctrNo: sessionUserInfo.prctrNo,
        bizSysCd: "CTL",
      };
      axios.json("/mobGuid/retrieveMblClus.do", param).then(function (result) {
        if (!_.isEmpty(result) && !_.isEmpty(result.data.body.pdfFilePth)) {
          var idx = result.data.body.pdfFilePth.lastIndexOf("/");
          var path = result.data.body.pdfFilePth.substring(0, idx + 1);
          var name = result.data.body.pdfFilePth.substring(idx + 1);

          variables.insClusDwldUrl =
            "/download.do?addFilePath=" + path + "&addFileNm=" + name;
        } else if (!_.isEmpty(result.data.body.hmpgFilePth)) {
          var fileName = param.prctrNo;

          var urlParam = {
            clusUrl: result.data.body.hmpgFilePth,
            fileName: state.currDate + "_" + fileName,
          };

          axios
            .json("/mobGuid/getURLToFile.do", urlParam)
            .then(function (result) {
              var pdfPath = result.data.pdfPath;
              var fileName = result.data.pdfName;

              variables.insClusDwldUrl =
                "/download.do?addFilePath=" +
                pdfPath +
                "&addFileNm=" +
                fileName;
            });
        } else {
          // dialog.alert("오류가 발생하였습니다. (PDF 정보를 찾을 수 없음)");
        }
      });
    }

    const sbcpDocDwld = () => {
      let param = {};
      param.prctrNo = sessionUserInfo.prctrNo;
      param.bizSysCd = "CTL";
      param.mngTrgCtnsKdCd = "119657";
      param.sndCtnsKdCd = "120445";
      param.enrlChnCd = "40";
      param.dataDivCd = "00014";

      if (isIOS) {
        param.ctnsCnfDivCd = "01";
      } else {
        param.ctnsCnfDivCd = "02";
      }
      util.saveLog("004", "청약서부본다운로드"); // 004 : 다운로드
      axios.json("/registPrctrCtnsCnfHis.do", param).then(function (result) {
        let dwldUrl =
          "/download.do?" +
          "addFilePath=/attach/sea/backup/" +
          state.currDate +
          "/" +
          sessionUserInfo.prctrNo +
          "/" +
          "&addFileNm=" +
          sessionUserInfo.prctrNo +
          "_inspe.pdf";
        if (!state.isInsClusDwld) {
          masterButton.label = "약관 다운로드";
        } else {
          masterButton.label = "서명전송";
        }
        downloadFrame.value.src = dwldUrl;
        state.isCnfSbcpDocDwld = true;
      });
    };

    const insClusDwld = () => {
      let param = {};
      param.prctrNo = sessionUserInfo.prctrNo;
      param.bizSysCd = "CTL";
      param.mngTrgCtnsKdCd = "119614";
      param.sndCtnsKdCd = "120445";
      param.enrlChnCd = "40";
      param.dataDivCd = "00014";

      if (isIOS) {
        param.ctnsCnfDivCd = "01";
      } else {
        param.ctnsCnfDivCd = "02";
      }
      util.saveLog("004", "약관다운로드"); // 004 : 다운로드
      axios.json("/registPrctrCtnsCnfHis.do", param).then(function (result) {
        if (!state.isCnfSbcpDocDwld) {
          masterButton.label = "청약서부본 다운로드";
        } else {
          masterButton.label = "서명전송";
        }

        downloadFrame.value.src = variables.insClusDwldUrl;
        state.isInsClusDwld = true;
      });
    };

    const transfer = () => {
      if (store.state.elcSgnInf.sgnTrnsFlag) {
        router.push({ name: "elcSgnComp" });
        return;
      }

      let date = util.formatDate(new Date(), "yyyymmdd");

      if (sessionUserInfo.inqStdDt != date) {
        dialog.alert("모바일전자서명은 발송당일만 서명전송이 가능합니다.");
        return;
      }

      if (!state.isCnfSbcpDocDwld) {
        sbcpDocDwld();
        return;
      }

      if (!state.isInsClusDwld) {
        insClusDwld();
        return;
      }

      let param = _.cloneDeep(sessionUserInfo);
      param.currentDate = util.formatDate(new Date(), "yyyymmdd");
      param = _.merge(param, store.state.elcSgnInf.acntInf);
      // param.crsData = store.state.elcSgnInf.crsData
      param.imageList = store.state.elcSgnInf.imageData;
      param.agrInf = store.state.elcSgnInf.agrInf;
      // param.useYn = "1"
      // param.pcsCtnsSndReqId = sessionUserInfo.dataId
      // param.ernpeDivNm = "비교안내문"

      let inspeTrgCoVo = _.filter(
        store.state.elcSgnInf.elcSgnTrgCoVo,
        (data) => data.ptyRlCd.indexOf("02") >= 0
      )[0];

      //예금주 당사자 존재여부 확인
      if (inspeTrgCoVo.ptyRlCd.indexOf("71") >= 0) {
        param.dporElcSgnYn = "Y";
      } else {
        param.dporElcSgnYn = "N";
      }

      // 출력물 생성 및 전송, 발송
      axios.json("/inspe/transferInspeSgn.do", param).then(function (result) {
        store.commit("elcSgnInf/changeSgnTrnsFlag", true);
        util.saveLog("003", "서명전송"); // 003 : 저장
        if (
          util.isEmpty(store.state.elcSgnInf.maInspeAge) ||
          store.state.elcSgnInf.maInspeAge >= 65 ||
          (variables.sbcpChnFlag && variables.pmmiCovYn) ||
          variables.inempYn
        ) {
          dialog
            .alert(
              "전화가입을 통한 갱신형 실손의료비 담보가입, " +
                "미성년자,만65세 이상 , 저축/연금 보험 또는 당사 설계사 임직원으로 체결된 계/피 동일계약 가입고객님께서는 " +
                "모바일 모니터링이 어렵습니다. 해피콜 1577-7711로 연락드리겠습니다. " +
                "감사합니다."
            )
            .then(function () {
              router.push({ name: "elcSgnComp" });
            });
        } else {
          //완전판매 모니터링 설문조사 페이지로 이동
          router.push({ name: "cmpltSal" });
        }
      });
    };

    return {
      state,
      sbcpDocDwld,
      insClusDwld,
      transfer,
      downloadFrame,
      load,
      sessionUserInfo,
      masterButton,
    };
  },
  methods: {
    dateFormat(date) {
      if (util.isEmpty(date)) return "";
      return util.formatDate(date, "yyyy-mm-dd");
    },
    numberFormat(number) {
      if (!number) {
        return 0;
      } else {
        return util.addCommas(number + "");
      }
    },
  },
};
</script>
